import React from 'react';
import styled from 'styled-components';
import { TABLET } from '../../utilities/breakpoints'

export const RadioButton = ({
  checked,
  value,
  label,
  name,
  id,
  onChange,
  disabled = false
}) => {
  const handleChange = (e) => {
    onChange(e);
  };

  return (
    <RadioButtonWrapper className={`${disabled ? "disabled" : ""}`}>
      <label htmlFor={id}>
        {label}
        <input
          type={'radio'}
          value={value}
          onChange={e => handleChange(e)}
          name={name}
          id={id}
          checked={checked}
          disabled={disabled}
          className={`radio-input ${checked ? 'checked' : ''}`}
        />
        <span className="radio" />
      </label>
    </RadioButtonWrapper>
  );
};

const RadioButtonWrapper = styled.div`
  position: relative;

  &:hover {
    .radio {
      background-color: rgba(112, 112, 112, 0.1);
    }
  }
  
  &.disabled {
    pointer-events: none;
  }

  /* hide browser default radio button */
  input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* custom radio button */
  .radio {
    cursor: pointer;
    position: absolute;
    top: 1px;
    left: 0;
    height: 20px;
    width: 20px;
    border: 1px solid rgba(112, 112, 112, 0.44);
    border-radius: 50%;
    margin: 0.375rem 0;

    &::before {
      content: '';
      position: absolute;
      top: 3px;
      left: 3px;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #F58220;
      display: none;
    }
  }
  
  .radio-input.checked + .radio {
    &:before {
      display: inline-block;
    }
  }

  input:focus + .radio {
    outline: 1px solid #F58220;
  }

  label {
    text-align: left;
    display: block;
    cursor: pointer;
    color: #000;
    font-size: 1rem;
    line-height: 1.4;
    padding: 0.375rem 1.5rem 0.375rem 30px;
  }

  &.b2b {
    label {
      font-size: 16px;
    }

    .radio {
      top: 1px;
    }
  }

  @media ${TABLET} {

  }
`;



// WEBPACK FOOTER //
// ./src/components/forms/radio-button.js